
    <!--
 * 竖版-页面背景
 * @LastEditTime: Tue Dec 17 2024 15:43:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_26FL21"  :class="[`normal`,`u_c_26FL21`]" ></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{},"zh-CN":{},"zh-TW":{},"en-US":{},"ja-JP":{},"ko-KR":{},"th-TH":{},"vi-VN":{},"de-DE":{},"fr-FR":{},"ru-RU":{},"es-ES":{},"pt-PT":{},"it-IT":{},"tr-TR":{},"pl-PL":{},"id-ID":{},"ar-SA":{}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '页面背景';

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.zh-CN{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.zh-TW{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.en-US{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.ja-JP{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.ko-KR{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.th-TH{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.vi-VN{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.de-DE{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.fr-FR{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.ru-RU{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.es-ES{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.pt-PT{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.it-IT{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.tr-TR{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.pl-PL{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.id-ID{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}.ar-SA{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:9.05rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/10/1728559438422-99.jpeg);
z-index:0;
max-width:10.00rem;

}
}
</style>
